<template>
  <b-modal :title="modalTitle" v-model="orphanRecordsModalOpen" @ok="closeModal()" ok-variant="info">
      <div v-html="modalMsg"></div>
      <div class="orphan-tree">
       <b-tree-view 
        :data="orphanRecords" 
        :contextMenu="false"
        :contextMenuItems="null">
       </b-tree-view>
      </div>
    </b-modal>
</template>
<script>
import { bTreeView } from 'bootstrap-vue-treeview';

export default {
  name: "OrphanRecordsModal",
  components: {
    bTreeView 
  },
  props: {
    modalTitle: {
      type: String,
      default:function(){
        return 'Orphan Records';
      }
    },
    modalMsg:{
      type: String,
      default:function(){
        return 'Orphan Records';
      }
    }
  },
  data() {
    return {
      orphanRecordsModalOpen:false,
      orphanRecords: [],
      oneOfOrphanRecordsScan_Exceeds1MBDynamoLimit: false
    }
  },
  mounted() {
  },
  watch: {
    markAsDeleted: function (val) {
      this.permenentDelete = !val;
    },
    permenentDelete: function (val) {
      this.markAsDeleted = !val;
    }
  },
  methods:{
    openModal(orphanRecords, oneOfOrphanRecordsScan_Exceeds1MBDynamoLimit){
      let that = this;
      that.orphanRecords=orphanRecords;
      that.oneOfOrphanRecordsScan_Exceeds1MBDynamoLimit=oneOfOrphanRecordsScan_Exceeds1MBDynamoLimit;
      that.orphanRecordsModalOpen=true;
    },
    closeModal() {
      let that = this;
      that.orphanRecordsModalOpen = false;
      that.orphanRecords=[];
      if(!that.oneOfOrphanRecordsScan_Exceeds1MBDynamoLimit){
        that.$emit('toggle', {deleteOrphanRecords: true});
      }else{
        that.$emit('toggle', {deleteOrphanRecords: false});
      }
    }
  }
}
</script>
<style scoped lang="less">
.delete-buttons{
  display: block;
  margin-top:10px;
  .btn{
    margin-right:10px;
  }
}
.orphan-tree{
  margin-top:10px;
  position: relative;
  height: 200px;
  overflow-y: scroll;
  .tree-view{
    min-height: 100%;
    width: auto;
    left: 5px;
    position: absolute;
  }
}
</style>